export const CardTypes = {
    VISA: 'VISA',
    MASTERCARD: 'MASTERCARD',
    JCB: 'JCB',
    AMERICANEXPRESS: 'AMERICAN EXPRESS',
    DISCOVER: 'DISCOVER',
    AMEX: 'AMEX',
};

export enum OrderStatuses {
    DELIVERED = 'DELIVERED',
    ORDERED = 'ORDERED',
    LABELLED = 'LABELLED',
    SHIPPED = 'SHIPPED'
}
